import { render, staticRenderFns } from "./que2.vue?vue&type=template&id=a95bed52&"
import script from "./que2.vue?vue&type=script&lang=js&"
export * from "./que2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports